import { OrganizationsPopoverProps } from "../utils/types";

const max_visible_organizations = 7;

export const OrganizationsPopover = ({
  organizations = [],
  onViewAll,
}: OrganizationsPopoverProps) => {
  const visibleOrgs = organizations.slice(0, max_visible_organizations);
  const remainingCount = Math.max(
    0,
    organizations.length - max_visible_organizations,
  );
  const hasMoreOrgs = remainingCount > 0;

  return (
    <div className="min-w-[180px] max-w-[180px] bg-popper-bg dark:bg-popper-bg-dk rounded-lg shadow-popper-blur-effect backdrop-blur-2xl border border-border-gray dark:border-border-gray-dk">
      <div className="flex flex-col gap-4 p-2">
        <div className="flex flex-col gap-1 max-h-[280px] overflow-y-auto">
          {visibleOrgs.map((org) => (
            <div
              key={org.client_code}
              className="bg-pure-white dark:bg-pure-white-dk border border-border-gray dark:border-border-gray-dk shadow-xs-blur rounded-md px-1.5 py-1 flex items-center gap-1"
            >
              <div className="w-[18px] h-[18px] overflow-hidden shrink-0">
                <img
                  src={org.client_logo}
                  alt={org.client_name}
                  className="w-full h-full object-cover"
                />
              </div>

              <span className="text-sm font-normal text-heading-text dark:text-heading-text-dk truncate">
                {org.client_name}
              </span>
            </div>
          ))}
        </div>

        {hasMoreOrgs && (
          <div className="flex items-center justify-between">
            <span className="text-xs font-medium text-gray-placeholder dark:text-gray-placeholder-dk">
              + {remainingCount} More...
            </span>
            <span
              className="text-md font-medium text-verba-blue dark:text-verba-blue-dk cursor-pointer hover:underline"
              onClick={onViewAll}
            >
              View All
            </span>
          </div>
        )}
      </div>
    </div>
  );
};
